import { combineReducers } from 'redux';
// import { localeReducer as locale } from 'react-localize-redux';
import policies from './policies';
import { reducer as formReducer } from 'redux-form'
import categories from "./categories";
import filterTypes from "./categories";
import pageLoad from "./pageLoad";
import { localeReducer as locale } from 'react-localize-redux';
export default combineReducers({
    categories,
    locale,
    policies,
    filterTypes,
    pageLoad,
    form: formReducer
});



// WEBPACK FOOTER //
// ./src/reducers/index.js